import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./global/mainlayout/MainLayout"
import LoginPage from "./login/LoginPage";
import ActiveGamePage from "./active-game/ActiveGamePage";
import StatsPage from "./stats/StatsPage";
import GamesPage from "./games/GamesPage";
import GameDetail from "./games/GameDetail";
import StartNewGamePage from "./new-game/StartNewGamePage";

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage/>} />

          <Route element={<MainLayout/>}>
            <Route path="/account/:userId/" element={<ActiveGamePage/>} /> 
            <Route path="/account/:userId/play" element={<ActiveGamePage/>} /> 
            <Route path="/account/:userId/new" element={<StartNewGamePage/>} /> 
            <Route path="/account/:userId/stats" element={<StatsPage/>} /> 
            <Route path="/account/:userId/games" element={<GamesPage/>} />
            <Route path="/account/:userId/games/:gameId" element={<GameDetail/>} />
          </Route>
        </Routes>
    </BrowserRouter>
  );
}

export default App;
